/**
 * FEMALE body rest skeleton — the Manny hierarchy (same 89 bones, names, order and bone-frame
 * conventions, so every clip binds unchanged) with every joint moved to the female mesh's
 * anatomy. Source geometry is uniformly 0.49x to metres; landmarks derive from the FBX's
 * authoring rig (client/model-library/female/skeleton.json).
 * Generated by client/test/build-female.mts — do not hand-edit; re-run `npm run build:female`.
 *
 * Tuple: [name, parentIndex, px, py, pz, qx, qy, qz, qw] (locals, metres)
 */
import type { MannyBoneDef } from "./mannyRig";

export const FEMALE_RIG: readonly MannyBoneDef[] = [
  ["root", -1, 0, -0.007508, 0, -0.707107, 0, 0, 0.707107],
  ["pelvis", 0, 0, 0.013396, 0.954692, -0.019105, -0.706848, 0.019106, 0.706849],
  ["spine_01", 1, 0.031399, 0, 0, 0, 0, 0.000001, 1],
  ["spine_02", 2, 0.057106, 0, 0, 0, 0, 0, 1],
  ["spine_03", 3, 0.061421, 0, 0, 0, 0, -0.000001, 1],
  ["spine_04", 4, 0.072789, 0, 0, 0.000004, -0.000001, 0, 1],
  ["spine_05", 5, 0.164072, 0, 0, -0.000004, 0.000001, 0, 1],
  ["neck_01", 6, 0.100127, 0, 0, 0, 0, -0.116622, 0.993176],
  ["neck_02", 7, 0.050735, 0, 0, -0.000001, 0, 0, 1],
  ["head", 8, 0.049149, 0, 0, 0.000001, 0, 0.139402, 0.990236],
  ["clavicle_l", 6, 0.057693, 0.031341, -0.044414, 0.019192, 0.720927, -0.018412, 0.6925],
  ["upperarm_l", 10, 0.07738, 0, 0, -0.01836, 0.483672, 0.024629, 0.87471],
  ["lowerarm_l", 11, 0.22522, 0, 0, 0.023708, 0.003272, -0.134675, 0.990601],
  ["lowerarm_twist_02_l", 12, 0.081186, 0, 0, 0.011478, -0.014877, 0.017495, 0.99967],
  ["lowerarm_twist_01_l", 12, 0.162372, 0, 0, 0.011478, -0.014877, 0.017495, 0.99967],
  ["hand_l", 12, 0.243558, 0, 0, -0.553736, 0.053049, 0.051595, 0.829398],
  ["middle_metacarpal_l", 15, 0.040703, -0.009086, -0.002205, -0.037291, -0.000386, -0.020259, 0.999099],
  ["middle_01_l", 16, 0.073527, 0, 0, 0, 0, 0.272051, 0.962283],
  ["middle_02_l", 17, 0.062324, 0, 0, 0, 0, 0.180255, 0.98362],
  ["middle_03_l", 18, 0.02983, 0, 0, 0, 0, 0.087156, 0.996195],
  ["pinky_metacarpal_l", 15, 0.039962, -0.003688, 0.02883, -0.218231, -0.188166, 0.058286, 0.955809],
  ["pinky_01_l", 20, 0.059775, -0.001725, -0.002397, 0.089984, 0.017016, 0.128066, 0.987528],
  ["pinky_02_l", 21, 0.04601, 0, 0, 0, 0, 0.184698, 0.982795],
  ["pinky_03_l", 22, 0.024597, 0, 0, 0, 0, 0.042896, 0.99908],
  ["ring_metacarpal_l", 15, 0.040685, -0.006541, 0.013164, -0.116599, -0.100569, -0.02566, 0.987741],
  ["ring_01_l", 24, 0.068069, -0.000502, -0.00025, 0.054216, 0.013177, 0.25354, 0.965714],
  ["ring_02_l", 25, 0.060009, 0, 0, 0, 0, 0.164738, 0.986337],
  ["ring_03_l", 26, 0.02731, 0, 0, 0, 0, 0.079921, 0.996801],
  ["thumb_01_l", 15, 0.055005, -0.009229, -0.013053, 0.650044, 0.350812, -0.096013, 0.667199],
  ["thumb_02_l", 28, 0.043446, 0, 0, 0.009012, 0, 0, 0.999959],
  ["thumb_03_l", 29, 0.030625, 0, 0, 0, 0, 0.087156, 0.996195],
  ["index_metacarpal_l", 15, 0.041531, -0.004638, -0.028688, 0.028966, 0.063705, -0.007109, 0.997523],
  ["index_01_l", 31, 0.070861, 0.000521, 0.002905, 0, 0, 0.202557, 0.97927],
  ["index_02_l", 32, 0.049193, 0, 0, 0, 0, 0.129597, 0.991567],
  ["index_03_l", 33, 0.031288, 0, 0, 0, 0, 0.109009, 0.994041],
  ["upperarm_twist_01_l", 11, 0.075073, 0, 0, -0.000054, -0.01879, -0.00285, 0.999819],
  ["upperarm_twist_02_l", 11, 0.150147, 0, 0, 0, 0, 0, 1],
  ["clavicle_r", 6, 0.057692, 0.031341, 0.044414, 0.72092, -0.019192, -0.692508, -0.018411],
  ["upperarm_r", 37, -0.07738, 0, 0.000002, -0.01836, 0.483682, 0.02463, 0.874704],
  ["lowerarm_r", 38, -0.225221, 0, 0, 0.023708, 0.003272, -0.134676, 0.990601],
  ["lowerarm_twist_02_r", 39, -0.081186, 0, 0, 0.011478, -0.014877, 0.017495, 0.99967],
  ["lowerarm_twist_01_r", 39, -0.162371, 0, 0, 0.011478, -0.014877, 0.017495, 0.99967],
  ["hand_r", 39, -0.243558, 0, 0.000001, -0.553737, 0.053061, 0.051604, 0.829395],
  ["middle_metacarpal_r", 42, -0.040702, 0.009091, 0.002204, -0.037291, -0.000386, -0.020259, 0.999099],
  ["middle_01_r", 43, -0.073528, -0.000001, 0, 0, 0, 0.272051, 0.962283],
  ["middle_02_r", 44, -0.062322, -0.000001, 0, 0, 0, 0.180255, 0.98362],
  ["middle_03_r", 45, -0.029829, 0, 0, 0, 0, 0.087156, 0.996195],
  ["pinky_metacarpal_r", 42, -0.039965, 0.003688, -0.028832, -0.218231, -0.188166, 0.058286, 0.955809],
  ["pinky_01_r", 47, -0.05977, 0.001728, 0.002398, 0.089984, 0.017016, 0.128066, 0.987528],
  ["pinky_02_r", 48, -0.046009, 0, 0, 0, 0, 0.184698, 0.982795],
  ["pinky_03_r", 49, -0.024596, 0, 0, 0, 0, 0.042896, 0.99908],
  ["ring_metacarpal_r", 42, -0.040682, 0.006547, -0.013164, -0.116599, -0.100569, -0.02566, 0.987741],
  ["ring_01_r", 51, -0.06807, 0.000499, 0.00025, 0.054216, 0.013177, 0.25354, 0.965714],
  ["ring_02_r", 52, -0.060008, 0, 0, 0, 0, 0.164738, 0.986337],
  ["ring_03_r", 53, -0.027309, 0.000001, 0, 0, 0, 0.079921, 0.996801],
  ["thumb_01_r", 42, -0.055005, 0.00923, 0.013053, 0.650069, 0.350776, -0.095983, 0.667198],
  ["thumb_02_r", 55, -0.043445, 0.000004, -0.000001, 0.009008, -0.000012, -0.000046, 0.999959],
  ["thumb_03_r", 56, -0.030626, 0, 0, 0, 0, 0.087156, 0.996195],
  ["index_metacarpal_r", 42, -0.04153, 0.004644, 0.028687, 0.028966, 0.063705, -0.007109, 0.997523],
  ["index_01_r", 58, -0.070861, -0.000523, -0.002906, 0, 0, 0.202557, 0.97927],
  ["index_02_r", 59, -0.049191, 0, 0, 0, 0, 0.129597, 0.991567],
  ["index_03_r", 60, -0.031289, 0, 0, 0, 0, 0.109009, 0.994041],
  ["upperarm_twist_01_r", 38, -0.075074, 0, -0.000001, -0.000054, -0.01879, -0.00285, 0.999819],
  ["upperarm_twist_02_r", 38, -0.150147, 0, -0.000002, 0, 0, 0, 1],
  ["thigh_r", 1, 0, 0, 0.100122, 0.02686, 0.070845, 0.997104, -0.006551],
  ["calf_r", 64, 0.407713, -0.003178, -0.022022, 0.003292, -0.009314, -0.105763, 0.994342],
  ["foot_r", 65, 0.434887, -0.002777, -0.017732, -0.046163, 0.039972, -0.1019, 0.992919],
  ["ball_r", 66, 0.053348, 0.115973, -0.004101, 0.038319, 0.015985, -0.618562, 0.784638],
  ["calf_twist_02_r", 65, 0.145085, 0, 0.000389, -0.000093, 0.002251, 0.023249, 0.999727],
  ["calf_twist_01_r", 65, 0.290172, 0, 0.000778, -0.000093, 0.002251, 0.023249, 0.999727],
  ["thigh_twist_01_r", 64, 0.136107, 0, 0, 0.000026, 0.002253, -0.011408, 0.999932],
  ["thigh_twist_02_r", 64, 0.272213, 0, 0, 0.000026, 0.002253, -0.011408, 0.999932],
  ["thigh_l", 1, 0, 0, -0.100122, 0.070845, -0.02686, 0.006551, 0.997104],
  ["calf_l", 72, -0.407713, 0.003179, 0.022021, 0.003292, -0.009315, -0.105763, 0.994342],
  ["foot_l", 73, -0.434887, 0.002777, 0.017732, -0.046162, 0.039973, -0.1019, 0.992919],
  ["ball_l", 74, -0.053348, -0.115973, 0.004101, 0.038318, 0.015985, -0.618562, 0.784638],
  ["calf_twist_02_l", 73, -0.145085, 0, 0, -0.000093, 0.002251, 0.023249, 0.999727],
  ["calf_twist_01_l", 73, -0.290172, 0, -0.000777, -0.000093, 0.002251, 0.023249, 0.999727],
  ["thigh_twist_01_l", 72, -0.136107, 0, 0, 0.000026, 0.002253, -0.011408, 0.999932],
  ["thigh_twist_02_l", 72, -0.272213, 0, 0, 0.000026, 0.002253, -0.011408, 0.999932],
  ["ik_foot_root", 0, 0, 0, 0, 0, 0, 0, 1],
  ["ik_foot_l", 80, 0.140877, 0.009943, 0.082376, 0.063632, -0.704247, 0.041376, 0.705886],
  ["ik_foot_r", 80, -0.140876, 0.009848, 0.082382, 0.705887, -0.041376, -0.704247, -0.063632],
  ["ik_hand_root", 0, 0, 0, 0, 0, 0, 0, 1],
  ["ik_hand_gun", 83, -0.477683, -0.156988, 1.044664, 0.59846, -0.009649, 0.5206, 0.608874],
  ["ik_hand_l", 84, 0.437336, -0.616698, 0.584081, -0.457766, 0.645509, -0.611366, 0],
  ["ik_hand_r", 84, 0, 0, 0, 0, 0, 0, 1],
  ["interaction", 0, 0, 0, 0, 0, 0, 0, 1],
  ["center_of_mass", 0, 0, 0, 0, 0, 0, 0, 1],
  ["eye_l", 9, 0.07847, -0.079695, -0.031653, 0, 0, 0, 1],
  ["eye_r", 9, 0.07847, -0.079695, 0.031654, 0, 0, 0, 1],
];

/** No simulated cloth chains on the female body yet (male: MALE_CLOTH). */
import type { MaleClothDef } from "./maleRig";
export const FEMALE_CLOTH: readonly MaleClothDef[] = [];
